if (!customElements.get('ez-parts-quantity')) {
  customElements.define('ez-parts-quantity', class extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
      this.syncButtons = this.syncButtons.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      this.addEventListener('input', this.syncButtons);
      this.addEventListener('change', this.syncButtons);
      queueMicrotask(this.syncButtons);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('input', this.syncButtons);
      this.removeEventListener('change', this.syncButtons);
    }

    handleClick(event) {
      const button = event.target.closest?.('button[name]');
      const input = this.querySelector('input[name="quantity"]');
      if (!button || !this.contains(button) || !input || button.disabled) return;
      if (button.name !== 'plus' && button.name !== 'minus') return;
      event.preventDefault();
      const previous = input.value;
      if (!Number.isFinite(input.valueAsNumber)) {
        input.value = input.min || '1';
      } else if (button.name === 'plus') {
        input.stepUp();
      } else {
        input.stepDown();
      }
      this.syncButtons();
      if (previous !== input.value) {
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    syncButtons() {
      const input = this.querySelector('input[name="quantity"]');
      if (!input) return;
      const value = input.valueAsNumber;
      const minus = this.querySelector('button[name="minus"]');
      const plus = this.querySelector('button[name="plus"]');
      if (minus) minus.disabled = Number.isFinite(value) && value <= Number(input.min || 1);
      if (plus) plus.disabled = input.max !== '' && Number.isFinite(value) && value >= Number(input.max);
    }
  });
}
